
Vue.component("slideshow", {
  data() {
    return {
      speed: 8,
      images: 0,
      currentImageIndex: 0,
      intervalId: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      const slideshowImages = this.$el.querySelectorAll('.slideshow-image');
      this.images = slideshowImages.length + 1
      this.startSlideshow();
    })
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    startSlideshow() {
      this.intervalId = setInterval(() => {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.images;
      }, this.speed * 1000);
    },
    jumpToIndex(index) {
      this.currentImageIndex = index;
      clearInterval(this.intervalId);
    },
  },
})

Vue.component("accordian", {
  data() {
    return {
      activeIndex: null,
    };
  },

  methods: {
    toggleAccordion(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
    },
  },
})

// cf7
Vue.component("contactForm", {
  data() {
    return {
      sending: false,
      success: false,
      errors: [],
      firstName: '',
      lastName: '',
      email: '',
      message: '',
      appartmentType: '',
      terms: false
    }
  },
  methods: {
    async submit() {

      this.errors = []
      this.sending = true
      var emailFormat = /\S+@\S+\.\S+/;

      if (!emailFormat.test(this.email) || !this.email) {
        this.errors.push('Invalid email address!')
        return
      }

      if (!this.firstName.length) {
        this.errors.push('Please enter your first name')
        return
      }

      if (!this.lastName.length) {
        this.errors.push('Please enter your last name')
        return
      }


      await this.postToCf7();
      this.sending = false
    },
    async postToCf7() {
      this.savingReport = true

      const url = myVueObj.site_url + `/wp-json/contact-form-7/v1/contact-forms/${myVueObj.contactFormID}/feedback`;
      const formData = new FormData();
      formData.append('firstName', this.firstName);
      formData.append('lastName', this.lastName);
      formData.append('email', this.email);
      formData.append('message', this.message);
      formData.append('appartmentType', this.appartmentType);

      try {
        const response = await fetch(url, {
          method: 'POST',
          body: formData,
        });

        const result = await response.json();
        console.error(result)

        if (result.status === 'mail_sent') {
          this.success = true;
        }
      } catch (error) {
        this.errors.push('Could not send message. Please try again.')
        console.error(error);
      }

    }
  }
})

Vue.component("carousel", {
  data() {
    return {
      images: 0,
      activeSlide: 0,
      slickOptions: {
        autoplay: true,
        navigation: false,
        infinite: true,
        arrows: false,
      }
    };
  },

  mounted() {
    this.$nextTick(() => {
      const slideshowImages = this.$el.querySelectorAll('.slick-slide:not(.slick-cloned)');
      this.images = slideshowImages.length
      this.$refs.carousel.$on("afterChange", this.updateActiveSlide);
      const leftButton = document.getElementById('left');
      const rightButton = document.getElementById('right');
      leftButton.addEventListener('click', this.prev);
      rightButton.addEventListener('click', this.next);
    })
  },

  beforeDestroy() {
    this.$refs.carousel.$off("afterChange", this.updateActiveSlide);
  },
  methods: {
    updateActiveSlide(index) {
      this.activeSlide = index;
    },
    next() {
      this.$refs.carousel.next()
    },
    prev() {
      this.$refs.carousel.prev()
    }
  },

  components: {
    VueSlickCarousel: window['vue-slick-carousel']
  },
})



Vue.mixin({
  data() {
    return {
      windowWidth: window.innerWidth,
      samplePlaying: false
    };
  },
  computed: {
    windowWidthPixels() {
      return this.windowWidth
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  methods: {
    playSample() {

      if (this.samplePlaying) {

        this.$refs['audioSample'].pause();
      } else {

        this.$refs['audioSample'].play();
      }
    
      this.samplePlaying = !this.samplePlaying;
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    }
  }
})


new Vue({
  el: document.getElementById("app"),
  methods: {
    parallaxBgImages() {
      const testimonialsParallax = document.querySelectorAll(".parallax__image");
      testimonialsParallax.forEach((element) => {
        console.log(element)
        gsap.to(element, {
          backgroundPosition: "0% 30%",
          ease: "none",
          scrollTrigger: {
            trigger: element,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        });
      });
    },
    createInlineStyles() {
      // loop through the page and grab all divs with the .inline-style class
      // then append the contents of the data-style attribute to a new <style></style> tag at the end of the body
      // this is a hack to get around the fact that we can't use inline styles in Vue templates
      let inlineStyles = document.querySelectorAll(".inline-style");
      let styleTag = document.createElement("style");
      styleTag.type = "text/css";
      document.body.appendChild(styleTag);
      for (let i = 0; i < inlineStyles.length; i++) {
        let inlineStyle = inlineStyles[i];
        let style = inlineStyle.getAttribute("data-style");
        styleTag.innerHTML += style;
      }
    },
  },
  mounted() {
    this.createInlineStyles();
    // const boxes = gsap.utils.toArray('section');
    // boxes.forEach((box, i) => {
    //   const anim = gsap.fromTo(box, { autoAlpha: 0, y: 50 }, { duration: 1, autoAlpha: 1, y: 0 });
    //   ScrollTrigger.create({
    //     trigger: box,
    //     animation: anim,
    //     toggleActions: 'play none none none',
    //     once: true,
    //   });
    // });
  },
});
